export default class AnswerRepository {
    constructor(answers = []) {
        this.answers = answers;
    }

    getAnswerById(questionId) {
        return this.answers.find((item) => parseFloat(item.id) === parseFloat(questionId)).value;
    }

    getAnswersByHeadId(questionId) {
        questionId = (String(questionId).includes('.') ? parseInt(String(questionId).replace(/\..*$/)) : parseInt(questionId)) + '.';

        return this.answers.filter((item) => String(item.id).startsWith(questionId));
    }

    getScoreForHeadId(questionId) {
        const answers = this.getAnswersByHeadId(questionId);

        if(answers[0].value === 'nee') {
            return 1;
        }

        switch(questionId) {
            case 1.1:

                if(answers[0].value === 'ja' && answers[2].value === 'Minder dan 12 kg' && answers[3].value === 'Minder dan 12 keer') {
                    return 1;
                }

                if(answers[0].value === 'ja' && answers[3].value === 'Meer dan 12 keer' && ['Minder dan 12 kg', '12 - 23 kg'].includes(answers[2].value)) {
                    return 0.5
                }

                if(answers[0].value === 'ja' && ['Minder dan 12 kg', '12 - 23 kg'].includes(answers[2].value)) {
                    return 0.5;
                }

                if(answers[0].value === 'ja' && answers[2].value === 'Meer dan 23 kg') {
                    return 0;
                }

                return 0;
                break;

            case 2.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Minder dan 25 kg') {
                    return 1;
                }

                return 0;
                break;

            case 3.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Minder dan 25 kg') {
                    return 1;
                }

                return 0;
                break;

            case 5.1:
                if(answers[0].value === 'ja') {
                    return 0;
                }

                return 1;
                break;

            case 4.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Minder dan 1 minuut' && answers[3].value === 'Minder') {
                    return 1;
                }

                if(answers[0].value === 'ja' && ['Tussen 1 en 4 minuten', 'Meer dan 4 minuten'].includes(answers[2].value) && answers[3].value === 'Minder') {
                    return 0.5;
                }

                return 0;
                break;

            case 6.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Minder dan 12,5 kg') {
                    return 1;
                }

                return 0;
                break;

            case 7.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Minder dan 15 kg') {
                    return 1;
                }

                return 0;
                break;

            case 8.1:
                if(answers[0].value === 'ja' && ['Ja, meestal', 'Af en toe'].includes(answers[3].value) && parseInt(answers[2].value) >= 4) {
                    return 0;
                }

                return 1;
                break;

            case 9.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Meer dan 12 keer per dienst') {
                    return 0;
                }

                return 1;
                break;

            case 10.1:
                if(answers[0].value === 'ja' && answers[3].value === 'Ja' && parseInt(answers[1].value) <= 2 && parseInt(answers[2].value) <= 6) {
                    return 1;
                }

                return 0;
                break;

            case 11.1:
                if(answers[0].value === 'ja' && parseInt(answers[2].value) <= 2 && parseInt(answers[3].value) <= 6) {
                    return 1;
                }

                if(answers[0].value === 'ja' && parseInt(answers[2].value) > 2 && parseInt(answers[3].value) > 6) {
                    return 0;
                }

                if(answers[0].value === 'ja' && (parseInt(answers[2].value) > 2 || parseInt(answers[3].value) > 6)) {
                    return 0.5;
                }

                return 0;
                break;

            case 12.1:
                if(answers[0].value === 'ja' && parseInt(answers[2].value) <= 1) {
                    return 1;
                }

                if(answers[0].value === 'ja' && parseInt(answers[2].value) > 1 && parseInt(answers[2].value) <= 4) {
                    return 0.5;
                }

                return 0;
                break;

            case 13.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Zelden of nooit') {
                    return 1;
                }

                if(answers[0].value === 'ja' && answers[2].value === 'Minder dan 5 keer per dienst') {
                    return 0.5;
                }

                return 0;
                break;

            case 14.1:
                if(answers[0].value === 'ja' && parseInt(answers[2].value) <= 2 && parseInt(answers[3].value) <= 4) {
                    return 1;
                }

                if(answers[0].value === 'ja' && parseInt(answers[2].value) > 2 && parseInt(answers[3].value) > 4) {
                    return 0;
                }

                if(answers[0].value === 'ja' && (parseInt(answers[2].value) > 2 || parseInt(answers[3].value) > 4)) {
                    return 0.5;
                }

                return 0;
                break;

            case 15.1:
                if(answers[0].value === 'ja' && parseInt(answers[2].value) <= 1 && parseInt(answers[3].value) <= 15) {
                    return 1;
                }

                return 0;
                break;

            case 16.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Minder dan 1 minuut' && answers[3].value === 'Minder') {
                    return 1;
                }

                if(answers[0].value === 'ja' && (answers[2].value === 'Minder dan 1 minuut' || answers[3].value === 'Minder')) {
                    return 0.5;
                }

                return 0;
                break;

            case 17.1:
                if(answers[0].value === 'ja' && answers[2].value === 'Altijd') {
                    return 1;
                }

                if(answers[0].value === 'ja' && answers[2].value === 'Meestal') {
                    return 0.5;
                }

                return 0;
                break;
        }
    }
}
